import React from "react";

export default class Header extends React.Component {
  render() {
    return (
      <header>
            <p className='lang'><span>JP</span> | <span>EN</span></p>
      </header>
    );
  }
}
